<template>
  <div>
    <datatable
      title="Position Locations"
      @create="createLocation"
      @delete="deleteLocation"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'position-locations',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'lat',
          value: 'lat'
        },
        {
          name: 'long',
          value: 'long'
        },
        {
          name: 'description',
          value: 'description'
        }
      ],
      data: [],
      operations: [],
      position_id: this.$route.query.position_id
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils
        .getResourceLocations({
          current_type: 'Position',
          current_resource_id: this.position_id
        })
        .then(response => {
          if (response == undefined || response[0] == undefined) {
            this.data = []
            return
          }
          this.data = Array.isArray(response) ? response : [response]
        })
    },
    deleteLocation (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.description,
        item_name: delete_data.description,
        method: 'deleteLocation',
        method_params: { id: delete_data.id, current_type: 'Position', current_resource_id: this.position_id }
      })
    },
    createLocation () {
      this.create({ designator: 'position-locations-form-modal', component_name: 'LocationsForm', is_create: true, resource_type: 'Position', resource_id: this.position_id, modal_title: 'Create new Location', position_status: this.$route.query.position_status })
    },
    editClick (data) {
      this.create({ designator: 'position-locations-form-modal', component_name: 'LocationsForm', data, resource_type: 'Position', resource_id: this.position_id, modal_title: data.description, company_id: this.$route.query.company_id, position_status: this.$route.query.position_status })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
<style scoped></style>
